import { print } from 'graphql';
import gql from 'graphql-tag';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface BorerStateTypeCategory extends BaseEntity {
  readonly description: string;
}
export type BorerStateTypeCategoryCollection = RxCollection<BorerStateTypeCategory> | null;
export type BorerStateTypeCategoryDocument = RxDocument<BorerStateTypeCategory>;

export const borerStateTypeCategorySchema: RxJsonSchema<BorerStateTypeCategory> = {
  type: 'object',
  version: 0,
  description: 'describes a BorerStateTypeCategory object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    updatedAt: { type: 'number' },
    isDeleted: { type: 'boolean' },
    version: { type: 'number' },
  },
};

export const borerStateTypeCategoryPullQueryBuilder = (doc: BorerStateTypeCategory) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }

  const query = print(gql`
    query borerStateTypeCategoryFeed($lastUpdateAt: Float!, $siteId: ID!, $limit: Int!) {
      borerStateTypeCategoryFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
        version
        updatedAt
        isDeleted
        id
        description
      }
    }
  `);

  return {
    query,
    variables: {
      lastUpdateAt: doc.updatedAt,
      siteId: rootStore.user.siteId,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export const borerStateTypeCategoryMigrationStrategies: MigrationStrategies = {
  // Placeholder for future
  // 1: (oldDoc: BorerStateTypeCategoryDocument) => {
  //   return {
  //     ...oldDoc,
  //   };
  // },
};

export default {};
